import React from 'react'
import { Result } from 'antd'
import ErrorLayout from 'Pages/Layout/ErrorLayout'
import { VerifyTokenRes } from 'Store/user/types'

type Props = {
  verifyData: VerifyTokenRes
  onClick?: () => void
}

const ErrorResult: React.FunctionComponent<Props> = ({ verifyData, onClick }) => {
  const resultError = (message: string): React.ReactNode => {
    return <Result status="500" title="ลิงค์นี้ไม่สามารถใช้งานได้" subTitle={message} />
  }

  const renderResult = (status: string): any => {
    switch (status) {
      case 'expired':
        return resultError('เนื่องจาก ลิงค์สำหรับเปลี่ยนรหัสผ่านของคุณหมดอายุแล้ว')
      case 'revoked':
        return resultError('เนื่องจาก คุณมีการขอเปลี่ยนรหัสผ่านใหม่ กรุณาตรวจสอบลิงค์ให้ถูกต้อง')
      case 'used':
        return resultError('เนื่องจาก คุณทำการเปลี่ยนรหัสผ่านสำเร็จแล้ว กรุณาลองเข้าสู่ระบบอีกครั้ง')
      default:
        break
    }
  }

  const resultNotfound = (): React.ReactNode => {
    return <Result status="404" title="URL ไม่ถูกต้อง" subTitle="ไม่พบข้อมูล Token ของคุณในระบบ" />
  }

  return (
    <ErrorLayout btnText="กลับไปหน้าแรก" onClick={onClick}>
      {verifyData ? renderResult(verifyData.status) : resultNotfound()}
    </ErrorLayout>
  )
}

export default ErrorResult
